import * as _ from 'underscore';
import { IActionContext } from '../helpers/ActionContext';
import { Module } from '../Module';
import { ActiveDirectoryGroupAction } from './ActiveDirectoryGroupAction';
import { CreateGroupDialogAction } from './CreateGroupDialogAction';
import { IModalOptions, ModalService, ModalSize } from './ModalService';

export class AddGroupsOptionsAction {

  public static $inject = ['ModalService'];
  private static reserveHeight = 450;

  constructor(
    private modal: ModalService) {
  }

  public showAddGroupsOptionsDialog(context: IActionContext): ng.IPromise<any> {

    const dialogInstance = this.modal.open({
      scope: context.scope,
      templateUrl: 'addGroupsOptionsDialog.html',
      size: ModalSize.fitToContent,
      position: _.extend(ModalService.anchoredTo(context.targetElement),
        { reserveHeight: AddGroupsOptionsAction.reserveHeight }),
      controller: AddGroupsOptionsDialogCtrl
    });

    return dialogInstance.result;
  }
}

Module.instance().service('AddGroupsOptionsAction', AddGroupsOptionsAction);

// controller

export interface IAddGroupsOptionsDialogScope extends ng.IScope {
  title: string;
  // functions tied to the various add buttons
  addLocalGroup(): void;
  importAdGroup(): void;
  // from modal dialog
  close: (result: any) => void;
  options: IModalOptions;
}

export class AddGroupsOptionsDialogCtrl {

  static $inject = [
    '$scope',
    'CreateGroupDialogAction',
    'ActiveDirectoryGroupAction'];

  constructor(
      $scope: IAddGroupsOptionsDialogScope,
      createGroupDialogAction: CreateGroupDialogAction,
      activeDirectoryGroupAction: ActiveDirectoryGroupAction) {

    $scope.addLocalGroup = () => {
      // Note: The order here is important, because $scope.close() will destroy the scope.
      // The promise is passed through so an action can be taken when the group creation is complete.
      const promise = createGroupDialogAction.showCreateGroupDialog($scope.$parent);
      $scope.close(promise);
    };

    $scope.importAdGroup= () => {
      // Note: The order here is important, because $scope.close() will destroy the scope.
      activeDirectoryGroupAction.showAddAdGroupDialog($scope.$parent);
      $scope.close({});
    };
  }

}

Module.instance().controller('AddGroupsOptionsDialogCtrl', AddGroupsOptionsDialogCtrl);
